export const fontSizes = {
    titles: [12, 14, 16, 18, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112],
    headings: [12, 14, 16, 18, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96],
    caseStudyHeroTitle: [12, 14, 16, 18, 20, 24, 28, 32, 40],
    paragraphs: [12, 14, 16, 18, 20, 24]
}

export const fontSizeScales = {
    "Sidebar": {
        heroTitle: 32,
        heroSubtitle: 24,
        projectTitle: 22,
        h1: 32,
        h2: 28,
        h3: 24,
        h4: 20,
        heroParagraph: 16,
        projectSubtitle: 14,
        p1: 14,
        p2: 12,
        navigation: 14,
        button: 14,
        secondaryButton: 12,
        label: 12,
        pageTitle: 32
    },
    "Small": {
        heroTitle: 45,
        heroSubtitle: 32,
        projectTitle: 22,
        h1: 32,
        h2: 28,
        h3: 24,
        h4: 20,
        heroParagraph: 18,
        projectSubtitle: 14,
        p1: 14,
        p2: 12,
        navigation: 14,
        button: 14,
        secondaryButton: 12,
        label: 12,
        pageTitle: 32
    },
    "Medium": {
        heroTitle: 60,
        heroSubtitle: 44,
        projectTitle: 24,
        h1: 44,
        h2: 36,
        h3: 28,
        h4: 24,
        heroParagraph: 20,
        projectSubtitle: 16,
        p1: 16,
        p2: 14,
        navigation: 16,
        button: 16,
        secondaryButton: 14,
        label: 14,
        pageTitle: 44
    },
    "Large": {
        heroTitle: 80,
        heroSubtitle: 56,
        projectTitle: 32,
        h1: 56,
        h2: 44,
        h3: 36,
        h4: 28,
        heroParagraph: 22,
        projectSubtitle: 18,
        p1: 18,
        p2: 16,
        navigation: 18,
        button: 18,
        secondaryButton: 16,
        label: 16,
        pageTitle: 56
    },
    "Huge": {
        heroTitle: 112,
        heroSubtitle: 72,
        projectTitle: 40,
        h1: 72,
        h2: 56,
        h3: 40,
        h4: 32
    }
}

export const fontStyleMapping = {
    heroTitle: "headline",
    heroSubtitle: "headline",
    heroParagraph: "text",
    h1: "headline",
    h2: "headline",
    h3: "headline",
    h4: "headline",
    p1: "text",
    p2: "text",
    projectTitle: "headline",
    projectSubtitle: "text",
    navigation: "text",
    button: "text",
    secondaryButton: "text",
    label: "text",
};

export const CTA_BUTTON_FONT_STYLE_KEYS = ['button', 'secondaryButton'];

export function isCtaButtonFontStyleKey(key) {
    return CTA_BUTTON_FONT_STYLE_KEYS.includes(key);
}

export const fontPresetMapping = {
    heroTitle: {FONT: "HEADING", WEIGHT: "HEADING"},
    heroSubtitle: {FONT: "HEADING", WEIGHT: "HEADING"},
    heroParagraph: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "PARAGRAPH"},
    h1: {FONT: "HEADING", WEIGHT: "HEADING"},
    h2: {FONT: "HEADING", WEIGHT: "HEADING"},
    h3: {FONT: "HEADING", WEIGHT: "HEADING"},
    h4: {FONT: "HEADING", WEIGHT: "HEADING"},
    p1: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "PARAGRAPH"},
    p2: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "PARAGRAPH"},
    projectTitle: {FONT: "HEADING", WEIGHT: "HEADING"},
    projectSubtitle: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "PARAGRAPH"},
    navigation: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "NAVIGATION"},
    button: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "BUTTON"},
    secondaryButton: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "BUTTON"},
    label: {FONT: "PARAGRAPH_AND_NAV", WEIGHT: "BUTTON"},
};

export function getFontWeightAsText(fontWeight) {
    switch (fontWeight) {
        case 100:
        case '100':
            return 'thin'
        case 200:
        case '200':
            return 'extra light'
        case 300:
        case '300':
            return 'light'
        case 400:
        case '400':
        case 'normal':
            return 'regular'
        case 500:
        case '500':
            return 'medium'
        case 600:
        case '600':
        case 'semi bold':
        case 'semibold':
            return 'semibold'
        case 700:
        case '700':
        case 'bold':
        // font-weight 800 & 900 fallback to 'bold'. See: https://gitlab.com/productstudio/folio/-/issues/107
        case 800:
        case '800':
        case 'extra bold':
        case 900:
        case '900':
        case 'black':
            return 'bold'
        default:
            return fontWeight.toUpperCase()
    }
}

export function getFontWeightAsNumber(fontWeight) {
    switch (fontWeight) {
        case 'light':
        case 'light italic':
            return '300'
        case 'regular':
        case 'regular light':
            return '400'
        case 'medium':
        case 'medium italic':
            return '500'
        case 'semibold':
        case 'semibold italic':
            return '600'
        case 'bold':
        case 'bold italic':
        default:
            return '700'
    }
}

export function translateScaleLabelToText(scaleLabel) {
    switch (scaleLabel) {
        case "S":
            return "Small"
        case "M":
            return "Medium"
        case "L":
            return "Large"
        case "XL":
        default:
            return "Huge"
    }
}

export function translateScaleTextToLabel(scaleText) {
    switch (scaleText) {
        case "Small":
            return "S"
        case "Medium":
            return "M"
        case "Large":
            return "L"
        case "Huge":
        default:
            return "XL"
    }
}